/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { isKeycloakAuthTypeEnabled } from 'utils/helpers';

import Service from './Service';

class InvitationService extends Service {
  fetchInvitationSuggestions({ searchQuery }) {
    const endpoint = isKeycloakAuthTypeEnabled() ? '/identity/users' : '/internal-api/users';
    return this.get(searchQuery ? `${endpoint}?search=${encodeURIComponent(searchQuery)}` : endpoint);
  }

  inviteExternalUser() {}

  resendInvitation() {}
}

export default new InvitationService();
